import type { SVGProps } from 'react';

const SvgRangeOutPoint = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M11 20c-.55 0-1-.45-1-1v-5c0-.27.11-.52.29-.71L11.58 12l-1.29-1.29A1 1 0 0 1 10 10V5c0-.55.45-1 1-1s1 .45 1 1v4.59l1.71 1.71c.39.39.39 1.02 0 1.41L12 14.42v4.59c0 .55-.45 1-1 1z"
    />
  </svg>
);
export default SvgRangeOutPoint;
